/*
src/pages/_app.tsx
*/
import '../styles/globals.css';
import type { AppProps } from 'next/app';
import Layout from '../components/Layout';
import Head from 'next/head';

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <Head>
        <link rel="icon" href="/SICONSPERU.ico" />
        <link rel="shortcut icon" href="/SICONSPERU.ico" />
        <link rel="apple-touch-icon" href="/SICONSPERU.ico" />
      </Head>
      <Layout>
        <Component {...pageProps} />
      </Layout>
    </>
  );
}

export default MyApp;